// routes.tsx
import { Route } from './sideBarMenu';

const routes: Route[] = [
    {
        path: "/company",
        name: "Manage Company",
    },
    {
        path: "/users",
        name: "Manage Users",
    },
    {
        path: "/service_users",
        name: "Manage Service Users",
    },
    {
        path: "/crops",
        name: "Manage Crops",
    },
    {
        path: "/classes",
        name: "Manage Classes",
    },
    {
        path: "/machines",
        name: "Manage Machines",
    },
    {
        path: "/roles",
        name: "Manage Roles",
    },
    {
        path: "/calibration",
        name: "Manage Calibration",
    },
];

export default routes;
